export const bazzarvoiceApi = {
  reviews: 'data/reviews.json?apiversion=5.4&passkey=cah1WIkImbf2DVLMKC23JrzLAn8zT9v3NUQhyIDTUuDKo'
  + '&_appId=com.farmatodo.app&Stats=Reviews&Limit=20',
  comments: 'data/submitreview.json?apiversion=5.4&passkey=cah1WIkImbf2DVLMKC23JrzLAn8zT9v3NUQhyIDTUuDKo&_appId=com.farmatodo.app',
  summary: 'data/display/0.2alpha/product/summary?PassKey=caRsE2BkjeLAPlvqv4kY8SPNrY032XNfzo6M2cKaZgNjY'
  + '&contentType=reviews,questions&reviewDistribution=primaryRating,recommended&rev=0&contentlocale=es*,en*,es_CO',
};
